// @ts-nocheck
import React, { useState } from 'react';
import { useFetchAdmin } from '../hooks/fetchName';
import ModalSettings from './ModalSettings';
import { useTranslation } from '../../i18n/LanguageContext';
import { CalendarDaysIcon, EnvelopeIcon, IdentificationIcon, KeyIcon, ShieldCheckIcon, UserCircleIcon } from '@heroicons/react/24/outline';

export const Settings = () => {
    const { t } = useTranslation();

    const adminName = useFetchAdmin();
    const [modalOpen, setModalOpen] = useState(false);

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    return (
        <section className="mt-8 overflow-hidden rounded-3xl border border-gray-200/80 bg-white shadow-[0_20px_55px_-35px_rgba(15,59,53,0.38)]">
            <div className="flex flex-col gap-5 border-b border-gray-100 bg-gradient-to-r from-white to-emerald-50/40 px-6 py-6 sm:flex-row sm:items-center sm:justify-between lg:px-8">
                <div>
                    <div className="flex items-center gap-3">
                        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-50 text-green-cl ring-1 ring-emerald-100"><UserCircleIcon className="h-6 w-6" /></span>
                        <div><h2 className="text-xl font-bold text-gray-950">{t('settings.accountInfo')}</h2><p className="mt-1 text-sm text-gray-500">{t('settings.accountInfoDescription')}</p></div>
                    </div>
                </div>
                <div className="shrink-0">
                    <button className="inline-flex h-11 items-center gap-2 rounded-xl bg-green-cl px-5 text-sm font-semibold text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-green-900 hover:shadow-md focus:outline-none focus:ring-4 focus:ring-emerald-100" onClick={handleOpenModal}><KeyIcon className="h-5 w-5" />{t('settings.changePassword')}</button>
                    <ModalSettings open={modalOpen} setOpen={handleCloseModal} />
                </div>
            </div>
            <dl className="grid grid-cols-1 gap-4 p-6 sm:grid-cols-2 lg:p-8">
                    <InfoItem icon={IdentificationIcon} label={t('settings.name')} value={adminName?.name} />
                    <InfoItem icon={EnvelopeIcon} label="Email" value={adminName?.email} />
                    <InfoItem icon={ShieldCheckIcon} label={t('settings.accountType')} value={
                            adminName?.role === "ADMIN"
                                ? t('role.admin')
                                : adminName?.role === "MANAGER"
                                    ? t('role.manager')
                                    : adminName?.role === "PARTNER"
                                        ? t('role.partner')
                                        : t('role.unknown')
                        } />
                    <InfoItem icon={CalendarDaysIcon} label={t('settings.createdAt')} value={adminName?.createAt} />
            </dl>
        </section>
    )
}

const InfoItem = ({ icon: Icon, label, value }) => (
    <div className="flex min-h-[92px] items-center gap-4 rounded-2xl border border-gray-100 bg-gray-50/70 px-5 py-4 transition hover:border-emerald-100 hover:bg-emerald-50/30">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-green-cl shadow-sm ring-1 ring-gray-100"><Icon className="h-5 w-5" /></span>
        <div className="min-w-0"><dt className="text-xs font-bold uppercase tracking-wider text-gray-400">{label}</dt><dd className="mt-1 truncate text-sm font-semibold text-gray-900">{value || '—'}</dd></div>
    </div>
);
